export default class ChatBotConfigWhatsAppModel {
  constructor({
    id = 0,
    providerAPIToken = '',
    providerIdentifier = '',
    providerId = 0,
    permitirAlertaTemplate = true,
  } = {}) {
    this.id = id
    this.providerAPIToken = providerAPIToken
    this.providerIdentifier = providerIdentifier
    this.providerId = providerId
    this.permitirAlertaTemplate = permitirAlertaTemplate
  }
}
